import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { useTaskStatusesRetrieval } from "@planzone/view-models";
import { VisibilitySwitch } from "@common/visibilitySwitch";
import { ActivityWatcher } from "@common/activityWatcher";
import { Props } from "./types";
import { Form } from "./form";
import { List } from "./list";
import { ToggleArrow } from "./toggleArrow";
import styles from "./styles.scss";

function Status(props: Props) {
  const { t } = useTranslation();
  const {
    statuses,
    retrieveTaskStatuses,
    isRequestPending,
    isRequestSuccess,
    isRequestFailure,
  } = useTaskStatusesRetrieval(props.project);

  const handleShow = (show: () => void) => {
    if (!isRequestSuccess && !isRequestPending && !isRequestFailure) {
      retrieveTaskStatuses(props.project);
    }
    show();
  };

  return (
    <VisibilitySwitch
      renderChildren={(isVisible, show, hide) => (
        <ActivityWatcher
          className={classNames(styles.status, {
            [styles.opened]: isVisible,
            [styles.readOnly]: !props.canEditStatus,
          })}
          blur={hide}
        >
          <div className={styles.main}>
            {props.status.color && props.status.label ? (
              <div
                className={classNames(styles.button, {
                  [styles.reduced]: props.isReduced,
                })}
                style={{ borderColor: props.status.color }}
                onClick={
                  props.canEditStatus ? () => handleShow(show) : undefined
                }
              >
                {!props.isReduced && (
                  <div
                    className={styles.square}
                    style={{ backgroundColor: props.status.color }}
                  />
                )}
                <span className={styles.paragraph}>
                  {t(`taskStatuses.${props.status.label}`, props.status.label)}
                </span>
                {props.canEditStatus && (
                  <ToggleArrow
                    className={styles.icon}
                    style={{ fill: props.status.color }}
                  />
                )}
              </div>
            ) : (
              <div className={styles.button} onClick={() => handleShow(show)}>
                <span className={styles.paragraph}>
                  {t("createStatus.noStatus")}
                </span>
                <ToggleArrow className={styles.icon} style={{}} />
              </div>
            )}
            {isVisible && (
              <div className={styles.menu}>
                <div className={styles.list}>
                  <List
                    statuses={statuses}
                    selectStatus={(status) => {
                      props.selectStatus(status);
                      hide();
                    }}
                  />
                </div>
              </div>
            )}
          </div>
        </ActivityWatcher>
      )}
    />
  );
}

export { Status };
